import { Injectable } from '@angular/core'
import { PaginationModel } from '../models/pagination.model'
import { SortingModel } from '../models/sorting.model'
import { HelperService } from './helper.service'
import { LocalStorageService } from './local-storage.service'

export interface IPFSReport {
  p?: PaginationModel
  f?: object
  c?: object
  s?: SortingModel
  o?: object
}

@Injectable({
  providedIn: 'root',
})
export class FilterStorageService {
  private _storage: { [key: string]: IPFSReport } = {}
  private _allowFilterSaving: boolean = true

  public set allowFilterSaving(value: boolean) {
    this._allowFilterSaving = value
  }

  constructor(private storageService: LocalStorageService) {}

  public getFilter(name: string): IPFSReport | null {
    name = this.getCookieName(name)
    if (name in this._storage) {
      return this._storage[name]
    }
    let pfsReport: IPFSReport | null = this.getCookieValue(name)
    if (pfsReport) {
      this._storage[name] = pfsReport
      return this._storage[name]
    }
    return null
  }

  public saveFilter(name: string, pfsReport: IPFSReport): void {
    if (HelperService.isEmptyObjectByValues(pfsReport)) {
      this.clearFilter(name)
      return
    }
    if (!this._allowFilterSaving) {
      return
    }
    name = this.getCookieName(name)
    pfsReport = this.getObjectWithoutNullValues(pfsReport)
    this.storageService.set(name, JSON.stringify(pfsReport))
    this._storage[name] = pfsReport
  }

  public clearFilter(name: string): void {
    name = this.getCookieName(name)
    this.storageService.delete(name)
    if (name in this._storage) {
      delete this._storage[name]
    }
  }

  public clearFilters(): void {
    for (const name in this._storage) {
      if (this._storage.hasOwnProperty(name)) {
        this.storageService.delete(name)
      }
    }
    this._storage = {}
  }

  private getCookieValue(name: string): IPFSReport | null {
    let jsonData = this.storageService.get(name)
    if (jsonData) {
      return JSON.parse(jsonData)
    }
    return null
  }

  private getCookieName(name: string): string {
    name = name.replace(/ /g, '_').toLowerCase()
    return `app.pfs.${name}`
  }

  private getObjectWithoutNullValues(pfsReport: IPFSReport): IPFSReport {
    if (pfsReport.f) {
      pfsReport.f = HelperService.getObjectWithoutNullValues(pfsReport.f)
    }
    if (pfsReport.c) {
      pfsReport.c = HelperService.getObjectWithoutNullValues(pfsReport.c)
    }
    return pfsReport
  }
}
